import { useState } from 'react';

const STORAGE_KEY = 'how-terminals-work-theme';

function readIsLight(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.classList.contains('light');
}

function applyTheme(next: 'light' | 'dark') {
  const isLight = next === 'light';
  document.documentElement.classList.toggle('light', isLight);
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
}

export function ThemeToggle() {
  const [mode, setMode] = useState<'light' | 'dark'>(() =>
    readIsLight() ? 'light' : 'dark',
  );

  const toggle = () => {
    const next = mode === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    setMode(next);
  };

  const isLight = mode === 'light';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
      title={isLight ? 'Use dark theme' : 'Use light theme'}
      className="fixed top-4 right-4 z-50 flex items-center gap-2 rounded border border-terminal-border bg-terminal-surface px-3 py-2 text-xs text-terminal-muted shadow-sm transition-colors hover:border-terminal-dim hover:text-terminal-fg"
    >
      <span aria-hidden>{isLight ? '☾' : '☀︎'}</span>
      <span>{isLight ? 'Dark' : 'Light'}</span>
    </button>
  );
}
